import { Card } from '../../components/Card';
import { Header } from '../../components/Header';

import styles from './Inicio.module.scss';

export default function Inicio() {
  return (
    <>
      <Header
        titulo='Assistente PNAE'
        descricao='Esta tecnologia social tem por objetivo ajudar pequenos agricultores familiares e gestores escolares à realizarem suas atividades e tomarem decisões acerca do Programa Nacional de Alimentação Escolar (PNAE).'
      />

      <main className={styles.inicio}>
        <section className={styles.cards}>
          <Card tipo='agricultor' />
          <Card tipo='escola' />
        </section>

        <section className={styles.logos}>
          <Card tipo='desenvolvedores' />
        </section>

        <section className={styles.logos}>
          <Card tipo='financiadores' />
        </section>

        <br />
        <br />
      </main>
    </>
  );
}
